<template>
  <section class="feedback-welcome feedback__step uk-cover-container uk-flex uk-flex-middle">
    <picture>
      <source srcset="@/assets/images/koniec.webp" media="(min-width: 960px)" />
      <source srcset="@/assets/images/koniec@tab.webp" media="(min-width: 640px)" />
      <source srcset="@/assets/images/koniec@mob.webp" />
      <img
        alt="powitania tło"
        src="@/assets/images/koniec.webp"
        data-uk-cover
        ref="backgroundImage"
      />
    </picture>
    <Fireworks ref="fireworks" />
    <div class="uk-container">
      <div class="feedback-welcome__content">
        <h2 class="feedback-welcome__header">Dziękujemy za wypełnienie ankiety</h2>
        <p class="feedback-welcome__description">
          Dzięki temu będziemy mogli doskonalić usługi naszej firmy
        </p>
        <span class="feedback-welcome__hash"> #poszerzamyperspektywy </span>
        <a href="/" class="button button--shadow"> powrót do solveit.pl </a>
      </div>
    </div>
  </section>
</template>
<script>
import Fireworks from "../global/Fireworks.vue";

export default {
  name: "ThankYou",
  props: {
    isMobile: {
      type: Boolean,
      require: true,
    },
  },
  components: {
    Fireworks,
  },
  computed: {
    backgroundImage() {
      return this.isMobile ? "koniec@mob.webp" : "koniec.webp";
    },
  },
  methods: {
    fireworks() {
      this.$refs.fireworks.fireHandler();
    },
  },
  mounted() {
    this.$refs.backgroundImage.setAttribute(
      "style",
      // eslint-disable-next-line comma-dangle
      `height:${window.innerHeight}px; width:${window.innerWidth}px;`
    );
  },
};
</script>
<style scoped lang="scss">
.feedback-welcome {
  background-color: $purpleDim;
  color: $white;
  position: relative;
  min-height: 100vh;
  width: 100%;

  &__header {
    font-size: 1.75rem;
    font-weight: 900;
    margin-bottom: rem(40px);
    max-width: 13.5rem;
    text-wrap: balance;

    @include media-min($sm) {
      max-width: 27rem;
    }

    @include media-min($lg) {
      font-size: 2.5rem;
      margin-bottom: rem(48px);
    }
  }

  &__description {
    font-size: 1.25rem;
    font-weight: 700;
    margin-bottom: rem(40px);
    max-width: 13.5rem;

    @include media-min($sm) {
      max-width: 27rem;
    }
  }

  &__hash {
    font-size: 1.25rem;
    font-weight: 500;
    color: $teal;
    display: block;
    margin-bottom: rem(95px);
  }

  .uk-container {
    position: relative;
    z-index: 10;
    width: 100%;
    max-width: rem(800px);
  }
}
</style>
